//this file contains functions corresponding to attendee actions 
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import {firestore as db} from './firebaseConfig';
var Filter = require('bad-words'),
    filter = new Filter();

//increments the field clicked by 1
//changes value in database and graph view 
//return true if successful, false otherwise
export async function handleReactionClick(option, sessionId, userId){
    const spam = await checkVoteSpam(sessionId, userId, option);
    if(spam.error) return false;
    else {
        //updates vote count 
        var collectionName = "meetings/" + sessionId + "/voteCount"
        db.collection(collectionName).where("reaction", "==", option).limit(1).get().then(
            query => {
                let d = query.docs[0];
                let item = d.data();
                item.count = item.count + 1;
                d.ref.update(item);
            }
            );

        //adds vote 
        var collectionName2 = "meetings/" + sessionId + "/votes"
        db.collection(collectionName2).add({
            reaction: option, 
            text: "", 
            timestamp: firebase.firestore.Timestamp.now(), 
            userId: userId
        }).then((docRef) => {
            //console.log("Document written with ID: ", docRef.id);
        })
        return true; 
    }
}
    
//checks if a user clicked the same reaction 3 or less seconds ago
//or reacted more than 5 times in the last 3 seconds
async function checkVoteSpam(sessionId, userId, reaction) {
    const totaLClicksRef = await db.collection("meetings/" + sessionId + "/votes")
                    .where("userId", "==", userId)
                    .where("timestamp", ">=", firebase.firestore.Timestamp.fromMillis(firebase.firestore.Timestamp.now().seconds*1000-3000))

    const totalClicks = await totaLClicksRef.get();
    const duplicates = await totaLClicksRef.where("reaction", "==", reaction)
                     .get();

    if(duplicates.size > 0) return {error: true, message: "too-many-duplicates"}
    else if(totalClicks.size >= 5) return {error: true, message: "too-many-clicks"}
    else return {error: false}
}

//so i can test things
export function testFxn(){
    const userID = "123";
    const sessionID = "456"
    const answers = ["yes", "A", 23]
    addAttendeeToSession(userID, sessionID, answers)
}


export async function handleMessage(message, sessionId, userID, fromAdmin, reply, receivingUserId, receivingMsgId){
    try {message = filter.clean(message);
    } catch (err) {
        console.error(err.message);
    }
    const spam = await checkMessageSpam(message, sessionId, userID);
    if(spam.error) throw spam.message;
    else{db.collection("meetings/" + sessionId + "/messages").add({
        flagged: false,
        text: message,
        timestamp: firebase.firestore.Timestamp.now(), 
        senderId: userID,
        fromAdmin: fromAdmin,
        reply: reply, 
        receivingUserId: receivingUserId,
        receivingMsgId: receivingMsgId
        });
    }
}

//checks if a user sent the same message 30 or less seconds ago
//or if they sent more than 2 messages in the last 10 seconds
async function checkMessageSpam(message, sessionId, userId) {
    const totalMessagesRef = db.collection("meetings/" + sessionId + "/messages")
        .where("senderId", "==", userId)
    
    const totalMessages = await totalMessagesRef.where("timestamp", ">=", firebase.firestore.Timestamp.fromMillis(firebase.firestore.Timestamp.now().seconds*1000-10000)).get();      
    const duplicates = await totalMessagesRef.where("text", "==", message).where("timestamp", ">=", firebase.firestore.Timestamp.fromMillis(firebase.firestore.Timestamp.now().seconds*1000-30000)).get();

    if(duplicates.size > 0) return {error: true, message: "duplicate-messages"}
    else if(totalMessages.size > 2) return {error: true, message: "too-many-messages"}
    return {error: false};
}

export async function addAttendeeToSession(userID, sessionID, survey){
    const meeting = await db.collection("meetings").doc(sessionID).get()
    const ended = meeting.data().endTime !== null;
    if(ended) return;
    
    const pastSessions = await db.collection("attendees").where("userId", "==", userID).where("sessionId", "==", sessionID).get()
    
    if(pastSessions.size === 0){
        db.collection("attendees").add({
            //flagged: false, 
            sessionId: sessionID, 
            userId: userID,
            surveyQuestions: survey.questions,
            surveyAnswers: survey.answers,
        });
    }
    else { //updates doc if user already visited session
        db.collection("attendees").doc(pastSessions.docs[0].id).update({
            //flagged: false, 
            sessionId: sessionID, 
            userId: userID,
            surveyQuestions: survey.questions,
            surveyAnswers: survey.answers,
        });
    }
}

//fetches latest/current session
//assumes that the current session is always the latest
export async function getLatestSession(){
    const snapshot = await db.collection("meetings").orderBy("date", "desc").orderBy("time", "desc").limit(1).get();
    return snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
    }))[0];
}

export async function getAllSessions(){
    const snapshot = await db.collection("meetings").orderBy("date", "desc").orderBy("time", "desc").get();
    return snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
    }));
}